import React, { Component } from "react";
import { Trans } from "react-i18next";

import DropIn from "braintree-web-drop-in-react";
import axios from "axios";
import Loader from "react-loader-spinner";
import "../../config/i18n";
import { withTranslation } from "react-i18next";

import ls from "local-storage";
import { options } from "../../config/options";

class BraceletPayment extends Component {
  instance;

  constructor(props) {
    super(props);
    this.state = {
      modal: false,
      buybutton: "buybutton",
      requestedBracelet: localStorage.getItem("bracelet_id"),
      requestedBraceletDetails: null,
      clientToken: null,
      api_url: localStorage.getItem("api_url"),
      lang: ls.get("LangKeySet") || options[0],
      langKey: ls.get("LangValue"),
    };
  }

  async componentDidMount() {
    const bracelet_id = localStorage.getItem("bracelet_id");
    axios
      .get(this.state.api_url + `getbraceletbyid/${this.state.requestedBracelet}`)
      .then((res) => {
        if (res.data.status) {
          this.setState({
            requestedBraceletDetails: res.data.result,
          });
          // console.log("---",this.state.requestedBraceletDetails);
        } else {
          console.log("error");
        }
      });

    axios.get(this.state.api_url + `generateclienttoken`).then((res) => {
      // console.log(res.data);
      if (res.data.token != null) {
        this.setState({
          clientToken: res.data.token,
        });
      }

      if (!this.state.clientToken) {
        this.setState({
          buybutton: "buybutton",
        });
      } else {
        setTimeout(() => {
          this.setState({
            buybutton: "buybuttonshow",
          });
        }, 2000);
      }
    });

    // If returned as JSON string
  }

  componentWillMount() {
    //alert(this.state.buybutton)
  }

  async buy() {
    //console.log(this.instance);

    // Send the nonce to your server
    const { nonce } = await this.instance.requestPaymentMethod();
    if (nonce) {
      this.setState({
        buybutton: "buybutton",
      });
    }
    var payment = new FormData();
    payment.set("pay_nonce", nonce);
    payment.set("price", this.state.requestedBraceletDetails.bracelet_price);
    payment.set("user_id", JSON.parse(localStorage.getItem("session_userid")));
    payment.set("bracelet_id", this.state.requestedBraceletDetails.bracelet_id);
    payment.set("currency_code", JSON.parse(localStorage.getItem("currency")));
    payment.set("language", this.state.langKey);

    axios({
      method: "post",
      url: this.state.api_url + "webpaybracelet",
      data: payment,
      config: { headers: { "Content-Type": "multipart/form-data" } },
    }).then((res) => {
      if (res.data.status) {
        const address_details = JSON.parse(
          localStorage.getItem("address_details")
        );
        address_details.req_status = 0;
        localStorage.setItem(
          "address_details",
          JSON.stringify(address_details)
        );
        //  localStorage.setItem('trans_id',res.data.result)
        this.props.history.push("/app/Profile/ReqBracelet");
      } else {
        this.props.history.push("/app/Profile/ReqBracelet");
      }
    });
  }

  render() {
    var style = {
      zIndex: 10,
      backgroundColor: "white",
      height: "100vh",
      width: "100%",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      //width:"100%",
      overflowY: "hidden",
    };
    if (this.state.clientToken && this.state.requestedBraceletDetails != null) {
      return (
        <div className="peopleShowHolder">
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              height: "90vh",
              justifyContent: "center",
            }}
          >
            <h5
              style={{
                textAlign: "center",
                margin: "0px 0px 10px 0px",
              }}
            >
              {" "}
              Payment Details
            </h5>

            <div
              style={{
                backgroundColor: "rgb(76, 175, 255)",
                color: "white",
                padding: "0.5rem",
                boxSizing: "border-box",
                display: "flex",
                justifyContent: "space-evenly",
                alignItems: "center",
                fontWeight: "600",
                fontSize: "16px",
                boxShadow: "0px 0px 5px  rgb(153, 153, 153)",
              }}
            >
              <label style={{ padding: "0", margin: "0" }}>
                Bracelet Id : {this.state.requestedBraceletDetails.bracelet_id}
              </label>
              <label style={{ padding: "0", margin: "0" }}>
                Bracelet Type :{" "}
                {this.state.requestedBraceletDetails.bracelet_name}
              </label>
              <label style={{ padding: "0", margin: "0" }}>
                Bracelet Price :{" "}
                {this.state.requestedBraceletDetails.bracelet_price} USD
              </label>
            </div>

            <DropIn
              options={{ authorization: this.state.clientToken }}
              onInstance={(instance) => (this.instance = instance)}
            />
            {this.state && this.state.clientToken && (
              <button
                className={this.state.buybutton}
                onClick={this.buy.bind(this)}
              >
                <Trans i18nKey="Buy">Buy</Trans>
              </button>
            )}
          </div>
        </div>
      );
    } else {
      return (
        <div>
          <div className="loder-icon">
            <div style={style} id="loader">
              <Loader type="Bars" color="#32A5D2" height={30} width={50} />
            </div>
          </div>
        </div>
      );
    }
  }
}

export default withTranslation("translations")(BraceletPayment);
